module.exports = {"632323100":"泽曲镇","632323101":"麦秀镇","632323102":"和日镇","632323200":"宁秀乡","632323202":"王加乡","632323203":"西卜沙乡","632323204":"多禾茂乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/632323.json
// module id = 2998
// module chunks = 0